import { render, staticRenderFns } from "./DashboardText.vue?vue&type=template&id=11393b57&scoped=true&functional=true&"
var script = {}
import style0 from "./DashboardText.vue?vue&type=style&index=0&id=11393b57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "11393b57",
  null
  
)

export default component.exports